import ApiController from '@/services/ApiController'

export class ValidationHelper {
  static hasPackstationKeyword(field: string | null | undefined): boolean {
    if (!field) return false
    const lowerField = field.toLowerCase()
    return (
      lowerField.includes('packstation') || lowerField.includes('paketshop')
    )
  }

  static hasPackstation(address: any): boolean {
    return (
      this.hasPackstationKeyword(address.company) ||
      this.hasPackstationKeyword(address.additional) ||
      this.hasPackstationKeyword(address.street_name) ||
      this.hasPackstationKeyword(address.first_name) ||
      this.hasPackstationKeyword(address.last_name) ||
      this.hasPackstationKeyword(address.city)
    )
  }

  static readonly validateAddressForPayment = async (
    paymentMethodCode: string,
    address: any,
    originalData: any | null = null
  ) => {
    if (address.street_number === '') {
      await _logAddressError(paymentMethodCode, 'street_number_error', address)
      return false
    }

    const streetNameLower = address.street_name.toLowerCase()
    if (
      (streetNameLower.includes('packstation') ||
        streetNameLower.includes('paketshop')) &&
      (address.additional === null ||
        (address.additional.match(/\d/g) ?? []).length < 6)
    ) {
      await _logAddressError(
        paymentMethodCode,
        'packstation_error',
        originalData
      )
      return false
    }

    return true
  }

  /**
   * Validates that an address has all required fields for a complete address.
   * Required fields: first_name, last_name, gender, street_name, street_number, zip, city, country
   * Optional fields: title (can be null)
   * @param addressData - The address object to validate
   * @returns true if address is complete, false otherwise
   */
  static isAddressComplete(addressData: any): boolean {
    if (!addressData) return false
    return !!(
      addressData.first_name &&
      addressData.last_name &&
      addressData.gender &&
      addressData.street_name &&
      addressData.street_number &&
      addressData.zip &&
      addressData.city &&
      addressData.country
    )
  }
}

const _logAddressError = async (
  paymentMethodCode: string,
  message: string,
  data: any | null
) => {
  let error = {
    message: message,
    details: {
      originalError: {
        data
      }
    }
  }

  await ApiController.logPaymentError(paymentMethodCode, error)
  throw new Error(message)
}
